export default __webpack_public_path__ + "static/media/x.b57ddc2a.svg";